import { render, staticRenderFns } from "./addKickPlayer.vue?vue&type=template&id=7a3a9a7e&scoped=true&"
import script from "./addKickPlayer.vue?vue&type=script&lang=js&"
export * from "./addKickPlayer.vue?vue&type=script&lang=js&"
import style0 from "./addKickPlayer.vue?vue&type=style&index=0&id=7a3a9a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a9a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3a9a7e')) {
      api.createRecord('7a3a9a7e', component.options)
    } else {
      api.reload('7a3a9a7e', component.options)
    }
    module.hot.accept("./addKickPlayer.vue?vue&type=template&id=7a3a9a7e&scoped=true&", function () {
      api.rerender('7a3a9a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/components/addKickPlayer.vue"
export default component.exports